const ModalModule = {
  state: {
    emailVerified: {
      shown: false
    },
    activationInfo: {
      show: false
    },
    videoIdentification: {
      show: false
    }
  },
  mutations: {
    markModalShown (state, modal) {
      if (typeof state[modal] === 'object') {
        state[modal].shown = true
      }
    },
    changeModalViewState (state, { modal, viewState }) {
      state[modal].show = viewState
    }
  },
  getters: {
    wasModalShown: (state) => (modal) => {
      if (typeof state[modal] === 'object') {
        return state[modal].shown
      }
      return true
    },
    viewModal: (state) => (modal) => {
      if (typeof state[modal] === 'object') {
        return state[modal].show
      }
    }
  }
}

export {
  ModalModule
}
